import { render, staticRenderFns } from "./DcmManagement.vue?vue&type=template&id=15599ac6&scoped=true"
import script from "./DcmManagement.vue?vue&type=script&lang=js"
export * from "./DcmManagement.vue?vue&type=script&lang=js"
import style0 from "./DcmManagement.vue?vue&type=style&index=0&id=15599ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15599ac6",
  null
  
)

export default component.exports